import { Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { metadataOptions } from "../helpers/metadata";

// Needed for e.g. Box and material SKUs
const MetadataSelector = ({label = "Add an attribute", onSelect = null, exclude = [], metaSet = "default"}) => {
    const [value, setValue] = useState("");
  
    let options = metadataOptions(metaSet, exclude);

    let input_id = label.toLowerCase().replace(" ","") + "_id";
    let meta_per_id = Object.fromEntries(options.map(obj => [obj.key, obj]))

    return (
      <FormControl key={`$(option.key)_ctrl`}>
      <InputLabel id={input_id}>{label}</InputLabel>
      <Select
        id="metadata-select"
        label={label}
        labelId={input_id}
        value={value}
        sx={{ width: 300 }}
        onChange={(event) => {
          if (onSelect) {
            setValue(event.target.value);
            onSelect(meta_per_id[event.target.value]);
          }
        }}
      >
        {options.map((option) => {
          return <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>
        })}
        </Select>
        </FormControl>
    );
  }

export { MetadataSelector };
